import {
  SCHWAB_IRA,
} from 'utils/financialAccountTypes.js'
import {
  getNextSection,
  getPreviousSection,
} from 'utils/financialAccountTypeNavigation'
import store from 'store'

export const getJointOwner = (jointOwners, financialAccountId) => {
  const jointOwner = jointOwners && jointOwners.find(jointOwner =>
    jointOwner.financialAccountId === financialAccountId)
  return (jointOwner && jointOwner.data && jointOwner.data.attributes) || null
}

export const getFinancialAccount = (financialAccounts, financialAccountId) => (
  financialAccounts && financialAccounts.find(financialAccount =>
    financialAccount.id === financialAccountId)
)

export const continueToNextSection = (props) => {
  const nextSectionAction = getNextSection(props)

  return store.dispatch(nextSectionAction)
}

export const getPreviousSectionInfo = (prevPageInfo) => {
  const {
    financialAccounts,
    financialAccountId,
    financialAccountType,
    jointOwner,
    isMobile,
    currentSection
  } = prevPageInfo

  return getPreviousSection({
    currentFinancialAccountId: financialAccountId,
    currentFinancialAccountType: financialAccountType,
    currentSection,
    financialAccounts,
    jointOwner,
    isMobile,
  })
}

export const showIraSubTypeSection = (subType) => {
  const { SEP_IRA,SIMPLE_IRA, INDIVIDUAL_401K } = SCHWAB_IRA.ACCOUNT_TYPES
  return [SEP_IRA,SIMPLE_IRA, INDIVIDUAL_401K].includes(subType)
}

export const showSuccessorCustodian = (subType) => {
  const { CUSTODIAL_IRA, CUSTODIAL_ROTH_IRA } = SCHWAB_IRA.ACCOUNT_TYPES
  return [CUSTODIAL_IRA, CUSTODIAL_ROTH_IRA].includes(subType)
}

export const effectiveDateYearOnly = (subType, employerEffectiveDateConfiguration) => {
  const {
    ACCOUNT_TYPES: {
      SIMPLE_IRA
    },
    EFFECTIVE_DATE_CONFIG: {
      AMENDMENT_AND_RESTATEMENT
    }
  } = SCHWAB_IRA

  return (
    subType === SIMPLE_IRA &&
      employerEffectiveDateConfiguration === AMENDMENT_AND_RESTATEMENT
  )
}

export const normalizeEffectiveDate = (stringDate) => {
  if (!stringDate) return ''

  const effectiveDate = stringDate.split('-')

  return `${effectiveDate[1]}/${effectiveDate[2]}/${effectiveDate[0]}`
}

export const denormalizeEffectiveDate = (stringDate) => {
  if (!stringDate) return ''

  const effectiveDate = stringDate.split('/')

  return `${effectiveDate[2]}-${effectiveDate[0]}-${effectiveDate[1]}`
}

export default {
  getJointOwner,
  getFinancialAccount,
  getPreviousSectionInfo,
  continueToNextSection,
  showIraSubTypeSection,
  effectiveDateYearOnly,
  normalizeEffectiveDate,
  denormalizeEffectiveDate
}



// WEBPACK FOOTER //
// ./src/utils/financialAccounts.js